import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../useAuth';
import { canAccess, firstAccessiblePath, GuardedRoute } from '../pages/merchent/routeAccess';

// Where each role lands after login (mirrors useLoginAuth).
const homeFor = (role: string | null) =>
  ({ ADMIN: '/neopass-admin', ECR_PROVIDER: '/ecr-provider', TERMINAL_MANAGER: '/terminals', MSP_USER: '/msp-portal' } as Record<string, string>)[role ?? ''] ??
  '/dashboard';

interface ProtectedRouteProps {
  element: React.ReactNode;
  access?: GuardedRoute; // merchant page key in routeAccess.ts
  roles?: string[]; // portal-level: only these roles may open it (e.g. MSP_USER for /msp-portal)
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, access, roles }) => {
  const { token, role, hasCapability, capabilitiesLoaded } = useAuth();

  useEffect
 

  if (token == null) return <Navigate to="/neopaas/portal/login" />;
  // Merchant-portal pages are not for other portals' users (they'd otherwise land on merchant Settings).
  if (access && role != null && ['ADMIN', 'ECR_PROVIDER', 'MSP_USER'].includes(role)) return <Navigate to={homeFor(role)} replace />;
  if (roles && (role == null || !roles.includes(role))) return <Navigate to={homeFor(role)} replace />;
  // Render right away when allowed. If denied, only redirect once capabilities have loaded —
  // before that hasCapability is just a role fallback and would wrongly bounce custom-role users.
  const ctx = { role, hasCapability };
  if (access && !canAccess(access, ctx)) {
    return capabilitiesLoaded ? <Navigate to={firstAccessiblePath(ctx)} replace /> : null;
  }
  return <>{element}</>;
  
};

export default ProtectedRoute;
